module.exports = __webpack_public_path__ + "static/media/service-square.8fee88aa.jpg";